import { getStoredAuthorizedDeviceId } from '../../utils/deviceTokenStorage';

/** Shape returned by GettelApi (AuthorizedDeviceDtos.cs). */
export interface AuthorizedDeviceApiDto {
  id: string;
  name: string;
  unit: string;
  isActive: boolean;
  lastUsedAt?: string | null;
  lastUsedAtUtc?: string | null;
  lastIp?: string | null;
  lastIpAddress?: string | null;
  createdAt?: string;
  createdAtUtc?: string;
  /** Optional — API may add later. */
  isCurrentDevice?: boolean;
  matchesCurrentToken?: boolean;
}

export interface AuthorizedDeviceViewModel {
  id: string;
  name: string;
  unit: string;
  isActive: boolean;
  lastUsedAt: string | null;
  lastIp: string | null;
  createdAt: string;
  isCurrentDevice: boolean;
}

export function mapAuthorizedDeviceFromApi(raw: AuthorizedDeviceApiDto): AuthorizedDeviceViewModel {
  const isActive = raw.isActive === true;
  const storedDeviceId = getStoredAuthorizedDeviceId();

  let isCurrentDevice = false;
  if (raw.isCurrentDevice === true || raw.matchesCurrentToken === true) {
    isCurrentDevice = isActive;
  } else if (storedDeviceId && raw.id === storedDeviceId) {
    isCurrentDevice = isActive;
  }

  return {
    id: raw.id,
    name: raw.name,
    unit: raw.unit,
    isActive,
    lastUsedAt: raw.lastUsedAt ?? raw.lastUsedAtUtc ?? null,
    lastIp: raw.lastIp ?? raw.lastIpAddress ?? null,
    createdAt: raw.createdAt ?? raw.createdAtUtc ?? '',
    isCurrentDevice,
  };
}

export function mapAuthorizedDevicesFromApi(items: AuthorizedDeviceApiDto[]): AuthorizedDeviceViewModel[] {
  return items.map(mapAuthorizedDeviceFromApi);
}
